import cart from '@ppcp/cart';
import {getSetting} from '@ppcp/utils';
import {MiniCartController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import PayPalGateway from "../gateways/PayPalGateway";

const settings = getSetting('ppcp_data');

const gateway = new PayPalGateway({
    id: 'ppcp',
    cart,
    settings: settings,
    controller: null // Will be set after controller creation
});

// Create cart controller with gateway
const controller = new MiniCartController({
    id: 'ppcp',
    cart,
    context: new Context('minicart'),
    gateway,
    settings
});

controller.initialize();